import { h } from '@stencil/core';
import isEmpty from 'lodash/isEmpty';
import cn from 'classnames';
import { processGlobalAnalyticsEvent, tryParse } from '@pes-ui/utils';
import { isBrowser } from '../../../globals/utils';
export class Subcategories {
  constructor() {
    this.getRangesCount = (subCategories) => {
      var _a;
      return (_a = subCategories === null || subCategories === void 0 ? void 0 : subCategories.reduce((sum, subCategory) => { var _a, _b; return ((_b = (_a = subCategory.ranges) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) + sum; }, 0)) !== null && _a !== void 0 ? _a : 0;
    };
    this.name = undefined;
    this.sourceId = undefined;
    this.commonFiltersFilterBy = undefined;
    this.commonFiltersProductFiltersLabel = undefined;
    this.commonFiltersShowRanges = undefined;
    this.commonFiltersClearAllLabel = undefined;
    this.commonFiltersOfferTypeLabel = undefined;
    this.rangePartofLabel = undefined;
    this.rangeProductsViewDetailsLabel = undefined;
    this.productRelationsViewProdLabel = undefined;
    this.viewOnLabel = undefined;
    this.readMoreLabel = undefined;
    this.readLessLabel = undefined;
    this.newFilters = undefined;
    this.hmcBanner = undefined;
    this.hideHMCBanner = false;
    this.subCategories = undefined;
    this.avoidAccents = undefined;
    this.isPBS = false;
    this.languageCode = undefined;
    this.countryCode = undefined;
    this._name = undefined;
    this._sourceId = undefined;
    this._commonFiltersFilterBy = undefined;
    this._commonFiltersProductFiltersLabel = undefined;
    this._commonFiltersShowRanges = undefined;
    this._commonFiltersClearAllLabel = undefined;
    this._commonFiltersOfferTypeLabel = undefined;
    this._rangePartofLabel = undefined;
    this._rangeProductsViewDetailsLabel = undefined;
    this._productRelationsViewProdLabel = undefined;
    this._viewOnLabel = undefined;
    this._readMoreLabel = undefined;
    this._readLessLabel = undefined;
    this._newFilters = undefined;
    this._hmcBanner = undefined;
    this._hideHMCBanner = undefined;
    this._subCategories = undefined;
    this._avoidAccents = undefined;
    this.storageName = undefined;
    this.currentPageStorageKey = undefined;
    this.categoryId = undefined;
    this.filteredSubCategories = undefined;
    this.isMobileViewVisible = false;
    this.selectedSectionsCount = 0;
    this.productsCount = undefined;
  }
  onFilterStateChanged(event) {
    const { filtersState } = event.detail;
    const areAllUnchecked = Object.values(filtersState).every((state) => !state.value);
    if (areAllUnchecked) {
      this.filteredSubCategories = this.subCategories;
      this.selectedSectionsCount = 0;
    }
    else {
      this.filteredSubCategories = this.subCategories.filter((subCategory) => filtersState[subCategory.id].value);
      this.selectedSectionsCount = this.filteredSubCategories.length;
    }
    this.productsCount = this.getRangesCount(this.filteredSubCategories);
  }
  onToggleFilterMobileViewVisibility() {
    this.isMobileViewVisible = !this.isMobileViewVisible;
  }
  trackAnalyticsEventListener(e) {
    const { event } = e.detail;
    if (event === 'refinementStateChanged') {
      const { refinementId } = e.detail;
      const { value, parentCategoryId, rootSectionId, } = this.filtrationSmartData.entities.filter[refinementId];
      const extraParams = {
        filterCategory: rootSectionId,
        filterSubCategory: rootSectionId !== parentCategoryId ? parentCategoryId : undefined,
        filterName: value,
      };
      processGlobalAnalyticsEvent(e, extraParams);
    }
  }
  get viewProductsLabel() {
    var _a;
    return (_a = this.commonFiltersShowRanges) === null || _a === void 0 ? void 0 : _a.replace(' (#number of ranges#)', '');
  }
  componentWillLoad() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    this.name = (_a = tryParse(this._name)) !== null && _a !== void 0 ? _a : this.name;
    this.sourceId = (_b = tryParse(this._sourceId)) !== null && _b !== void 0 ? _b : this.sourceId;
    this.commonFiltersFilterBy = (_c = tryParse(this._commonFiltersFilterBy)) !== null && _c !== void 0 ? _c : this.commonFiltersFilterBy;
    this.commonFiltersProductFiltersLabel = (_d = tryParse(this._commonFiltersProductFiltersLabel)) !== null && _d !== void 0 ? _d : this.commonFiltersProductFiltersLabel;
    this.commonFiltersShowRanges = (_e = tryParse(this._commonFiltersShowRanges)) !== null && _e !== void 0 ? _e : this.commonFiltersShowRanges;
    this.commonFiltersClearAllLabel = (_f = tryParse(this._commonFiltersClearAllLabel)) !== null && _f !== void 0 ? _f : this.commonFiltersClearAllLabel;
    this.commonFiltersOfferTypeLabel = (_g = tryParse(this._commonFiltersOfferTypeLabel)) !== null && _g !== void 0 ? _g : this.commonFiltersOfferTypeLabel;
    this.rangePartofLabel = (_h = tryParse(this._rangePartofLabel)) !== null && _h !== void 0 ? _h : this.rangePartofLabel;
    this.rangeProductsViewDetailsLabel = (_j = tryParse(this._rangeProductsViewDetailsLabel)) !== null && _j !== void 0 ? _j : this.rangeProductsViewDetailsLabel;
    this.productRelationsViewProdLabel = (_k = tryParse(this._productRelationsViewProdLabel)) !== null && _k !== void 0 ? _k : this.productRelationsViewProdLabel;
    this.viewOnLabel = (_l = tryParse(this._viewOnLabel)) !== null && _l !== void 0 ? _l : this.viewOnLabel;
    this.readMoreLabel = (_m = tryParse(this._readMoreLabel)) !== null && _m !== void 0 ? _m : this.readMoreLabel;
    this.readLessLabel = (_o = tryParse(this._readLessLabel)) !== null && _o !== void 0 ? _o : this.readLessLabel;
    this.newFilters = (_p = tryParse(this._newFilters)) !== null && _p !== void 0 ? _p : this.newFilters;
    this.hmcBanner = (_q = tryParse(this._hmcBanner)) !== null && _q !== void 0 ? _q : this.hmcBanner;
    this.hideHMCBanner = (_r = tryParse(this._hideHMCBanner)) !== null && _r !== void 0 ? _r : this.hideHMCBanner;
    this.subCategories = (_s = tryParse(this._subCategories)) !== null && _s !== void 0 ? _s : this.subCategories;
    this.avoidAccents = (_t = tryParse(this._avoidAccents)) !== null && _t !== void 0 ? _t : this.avoidAccents;
    this.filteredSubCategories = (_u = this.subCategories) !== null && _u !== void 0 ? _u : [];
    this.productsCount = this.getRangesCount(this.subCategories);
    this.filtrationSmartData = this.normalizeFilters();
  }
  isHMCEnabled() {
    return !this.hideHMCBanner && !isEmpty(this.hmcBanner);
  }
  normalizeFilters() {
    const { refinements, filterCategory, filterSubCategory } = this.newFilters;
    const filter = refinements === null || refinements === void 0 ? void 0 : refinements.reduce((result, filterItem) => {
      const { label, sourceId } = filterItem;
      const hasSectionSingleFilter = refinements.length === 1;
      result[sourceId] = {
        label,
        value: sourceId,
        count: null,
        isChecked: hasSectionSingleFilter,
        isDisabled: hasSectionSingleFilter,
        rootSectionId: filterCategory,
        parentCategoryId: filterSubCategory,
      };
      return result;
    }, {});
    const entities = {
      filter,
      section: {
        [filterCategory]: {
          name: this.commonFiltersOfferTypeLabel,
          isCollapsible: false,
          type: 'multi',
          filters: refinements.map((refinement) => refinement.sourceId),
          sections: [],
          rootSectionId: filterCategory,
          parentCategoryId: filterSubCategory,
        },
      },
    };
    const result = {
      entities,
      result: this.subCategories.length ? [filterCategory] : [],
    };
    return result;
  }
  renderFilters() {
    return (h("pes-responsive-filters", { filtrationSmartData: this.filtrationSmartData, resetButtonLabel: this.commonFiltersClearAllLabel, visibleRefinementsPerFacetCount: Infinity, headerLabelDesktop: this.commonFiltersFilterBy, headerLabelMobile: this.commonFiltersProductFiltersLabel, viewProductsLabel: this.viewProductsLabel, isMobileViewVisible: this.isMobileViewVisible, isMobileCategorySelected: true, selectedSectionsCount: this.selectedSectionsCount, productsCount: this.productsCount, categories: [], onShowMobileFilter: () => (this.isMobileViewVisible = true) }));
  }
  render() {
    var _a;
    return (h("main", { class: "subcategories__listing" }, h("div", { class: cn('subcategories__banner-container', {
        'subcategories__banner-container--prerender': this.isHMCEnabled() && this.hmcBanner,
      }) }, this.isHMCEnabled() && isBrowser() && (h("pes-hmc-banner", { categoryName: this.hmcBanner.categoryName, labels: this.hmcBanner.labels, sourceId: this.hmcBanner.pimId, categoryProductConfiguratorUrl: this.hmcBanner.categoryProductConfiguratorUrl, hasQuestionnaire: this.hmcBanner.hasQuestionnaire, questionnaireUrl: this.hmcBanner.questionnaireUrl, rangeTooltipUrl: this.hmcBanner.rangeTooltipUrl, selectorConfigUrl: this.hmcBanner.selectorConfigUrl, isExternalProductConfiguratorUrl: this.hmcBanner.isExternalProductConfiguratorUrl, hmcHost: this.hmcBanner.host, token: this.hmcBanner.token, channel: this.hmcBanner.channel, pageSource: this.hmcBanner.pageSource }))), h("aside", { class: "subcategories__aside-filters" }, this.renderFilters()), h("aside", { class: "subcategories__category-wrapper" }, h("pes-subcategory-list", null, (_a = this.filteredSubCategories) === null || _a === void 0 ? void 0 : _a.map((subcategory, id) => (h("pes-subcategory-block", { slot: "pes-subcategory-block", key: subcategory.id, subCategory: subcategory, rangePartofLabel: this.rangePartofLabel, viewOnLabel: this.viewOnLabel, productRelationsViewProdLabel: this.productRelationsViewProdLabel, rangeProductsViewDetailsLabel: this.rangeProductsViewDetailsLabel, readMoreLabel: this.readMoreLabel, readLessLabel: this.readLessLabel, avoidAccents: this.avoidAccents, isFirstBlock: id === 0, currentPageStorageKey: this.currentPageStorageKey, storageName: this.storageName })))))));
  }
  static get is() { return "pes-subcategories"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["subcategories.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["subcategories.css"]
    };
  }
  static get properties() {
    return {
      "name": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "Circuit Breakers"
            }],
          "text": "name of the category"
        },
        "attribute": "name",
        "reflect": false
      },
      "sourceId": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "source id for hmc banner"
        },
        "attribute": "source-id",
        "reflect": false
      },
      "commonFiltersFilterBy": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "label for \"Filter by\" (on desktop)"
        },
        "attribute": "common-filters-filter-by",
        "reflect": false
      },
      "commonFiltersProductFiltersLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "label for \"Filters\" (on mobile)"
        },
        "attribute": "common-filters-product-filters-label",
        "reflect": false
      },
      "commonFiltersShowRanges": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "label for \"View ranges\" (on mobile)"
        },
        "attribute": "common-filters-show-ranges",
        "reflect": false
      },
      "commonFiltersClearAllLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "label for \"Reset all\""
        },
        "attribute": "common-filters-clear-all-label",
        "reflect": false
      },
      "commonFiltersOfferTypeLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "label for filter type"
        },
        "attribute": "common-filters-offer-type-label",
        "reflect": false
      },
      "rangePartofLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "label for \"Part of #MasterRangeName#\""
        },
        "attribute": "range-partof-label",
        "reflect": false
      },
      "rangeProductsViewDetailsLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "label for \"View details\""
        },
        "attribute": "range-products-view-details-label",
        "reflect": false
      },
      "productRelationsViewProdLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "label for \"View products\""
        },
        "attribute": "product-relations-view-prod-label",
        "reflect": false
      },
      "viewOnLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "label for \"View on #domain_name#\""
        },
        "attribute": "view-on-label",
        "reflect": false
      },
      "readMoreLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "label for \"Read more\""
        },
        "attribute": "read-more-label",
        "reflect": false
      },
      "readLessLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "label for \"Read less\""
        },
        "attribute": "read-less-label",
        "reflect": false
      },
      "newFilters": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TCategoryFilters",
          "resolved": "{ filterCategory: string; filterSubCategory: string; refinements: TCategoryRefinements[]; }",
          "references": {
            "TCategoryFilters": {
              "location": "import",
              "path": "../../category-subcategory-listing/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "list of subcategory names for filter"
        }
      },
      "hmcBanner": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "THMCBanner",
          "resolved": "{ sourceId?: string; parentCategoryId?: string; categoryName?: string; labels?: THMCBannerLabels; hasQuestionnaire?: boolean; categoryProductConfiguratorUrl?: string; questionnaireUrl?: string; rangeTooltipUrl?: string; selectorConfigUrl?: string; isExternalProductConfiguratorUrl?: boolean; pimId?: string; host?: string; token?: string; channel?: string; pageSource?: string; }",
          "references": {
            "THMCBanner": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "data for Help Me Choose\npass null to disable it"
        }
      },
      "hideHMCBanner": {
        "type": "boolean",
        "mutable": true,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "hide Help Me Choose block"
        },
        "attribute": "hide-h-m-c-banner",
        "reflect": false,
        "defaultValue": "false"
      },
      "subCategories": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TSubCategory[]",
          "resolved": "TSubCategory[]",
          "references": {
            "TSubCategory": {
              "location": "import",
              "path": "../../category-subcategory-listing/types"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "list of subcategories"
        }
      },
      "avoidAccents": {
        "type": "boolean",
        "mutable": true,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Styling title and description of range-card"
        },
        "attribute": "avoid-accents",
        "reflect": false
      },
      "isPBS": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Defines whether the component is integrated to PBS."
        },
        "attribute": "is-p-b-s",
        "reflect": false,
        "defaultValue": "false"
      },
      "languageCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "language-code",
        "reflect": false
      },
      "countryCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "country-code",
        "reflect": false
      },
      "_name": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-name",
        "reflect": false
      },
      "_sourceId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-source-id",
        "reflect": false
      },
      "_commonFiltersFilterBy": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-common-filters-filter-by",
        "reflect": false
      },
      "_commonFiltersProductFiltersLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-common-filters-product-filters-label",
        "reflect": false
      },
      "_commonFiltersShowRanges": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-common-filters-show-ranges",
        "reflect": false
      },
      "_commonFiltersClearAllLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-common-filters-clear-all-label",
        "reflect": false
      },
      "_commonFiltersOfferTypeLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-common-filters-offer-type-label",
        "reflect": false
      },
      "_rangePartofLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-range-partof-label",
        "reflect": false
      },
      "_rangeProductsViewDetailsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-range-products-view-details-label",
        "reflect": false
      },
      "_productRelationsViewProdLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-product-relations-view-prod-label",
        "reflect": false
      },
      "_viewOnLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-view-on-label",
        "reflect": false
      },
      "_readMoreLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-read-more-label",
        "reflect": false
      },
      "_readLessLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-read-less-label",
        "reflect": false
      },
      "_newFilters": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-new-filters",
        "reflect": false
      },
      "_hmcBanner": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-hmc-banner",
        "reflect": false
      },
      "_hideHMCBanner": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-hide-hmc-banner",
        "reflect": false
      },
      "_subCategories": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-sub-categories",
        "reflect": false
      },
      "_avoidAccents": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-avoid-accents",
        "reflect": false
      },
      "storageName": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "storage-name",
        "reflect": false
      },
      "currentPageStorageKey": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "SUBCATEGORY/4200"
            }],
          "text": "key for getting breadcrumbs from the indexDB"
        },
        "attribute": "current-page-storage-key",
        "reflect": false
      },
      "categoryId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "4200"
            }],
          "text": "The ID of the category."
        },
        "attribute": "category-id",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "filteredSubCategories": {},
      "isMobileViewVisible": {},
      "selectedSectionsCount": {},
      "productsCount": {}
    };
  }
  static get listeners() {
    return [{
        "name": "filterStateChanged",
        "method": "onFilterStateChanged",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "toggleMobileView",
        "method": "onToggleFilterMobileViewVisibility",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "track_analytics",
        "method": "trackAnalyticsEventListener",
        "target": undefined,
        "capture": false,
        "passive": false
      }];
  }
}
